(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
  const body = document.querySelector("body");

  function getHeaderHeight() {
    const headerGroup = document.querySelectorAll(
      "#shopify-section-header, #shopify-section-announcement-banner"
    );
    return [...headerGroup].reduce((total, el) => total + el.offsetHeight, 0);
  }

  function setHeaderHeight() {
    body.style.setProperty("--height-header-group", `${getHeaderHeight()}px`);
  }

  const dropdowns = document.querySelectorAll(".desktop-navigation .site-nav__dropdown");
  const overlays = document.querySelectorAll(".desktop-navigation .dropdown-overlay");

  function setOverlayHeights() {
    overlays.forEach((overlay, index) => {
      const dropdown = dropdowns[index];
      if (dropdown) {
        const dropdownHeight = `${dropdown.offsetHeight + 60}px`;
        overlay.style.setProperty("--height-overlay", dropdownHeight);
      }
    });
  }

  function setStyles() {
    setHeaderHeight();
    setOverlayHeights();
  }

  setStyles();

  window.addEventListener("resize", setStyles);

  // NDK 24-sep-2026: el velo blanco del desplegable (.dropdown-overlay) se colocaba en «altura del grupo de cabecera − 38 px».
  // Con la página arriba empezaba 38 px por encima del final de la cabecera y tapaba la mitad de abajo de Farmacias,
  // buscador, cuenta y carrito. Ahora se mide al abrir cada desplegable: empieza en el borde inferior real de .site-header
  // y acaba 20 px por debajo de la lista. Se recalcula si se hace scroll con el desplegable abierto.
  const siteHeader = document.querySelector(".site-header");
  let ndkNavAbierto = null;
  function ndkColocaOverlay(item) {
    const overlay = item.querySelector(".dropdown-overlay");
    const dropdown = item.querySelector(".site-nav__dropdown");
    if (!siteHeader || !overlay || !dropdown) return;
    const top = Math.max(0, Math.round(siteHeader.getBoundingClientRect().bottom));
    const bottom = Math.round(dropdown.getBoundingClientRect().bottom) + 20;
    overlay.style.setProperty("--ndk-overlay-top", `${top}px`);
    overlay.style.setProperty("--height-overlay", `${Math.max(0, bottom - top)}px`);
  }
  document.querySelectorAll(".desktop-navigation .site-nav--has-dropdown").forEach((item) => {
    item.addEventListener("mouseenter", () => { ndkNavAbierto = item; ndkColocaOverlay(item); });
    item.addEventListener("mouseleave", () => { if (ndkNavAbierto === item) ndkNavAbierto = null; });
  });
  window.addEventListener("scroll", () => { if (ndkNavAbierto) ndkColocaOverlay(ndkNavAbierto); }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();
})();
